export const GET_USER = 'app/App/GET_USER';
export const GET_USER_SUCCESS = 'app/App/GET_USER_SUCCESS';
export const GET_USER_FAILURE = 'app/App/GET_USER_FAILURE';
export const LOGOUT = 'app/App/LOGOUT';
export const UPDATE_STRIPE_ID = 'app/App/UPDATE_STRIPE_ID';
export const GET_ERROR_MESSAGE = 'app/App/GET_ERROR_MESSAGE';

export const TOGGLE_OVERFLOW = 'app/App/TOGGLE_OVERFLOW';
export const ADD_OVERFLOW = 'app/App/ADD_OVERFLOW';
export const REMOVE_OVERFLOW = 'app/App/REMOVE_OVERFLOW';
export const SET_PAGE_TITLE = 'app/App/SET_PAGE_TITLE';